<template>
    <Toast/>
    <div>
        <div v-if="$can('add','supplier_responsible') && !service_sheet" class="pt-4 pb-2 flex justify-content-between align-items-end">
            <h1 class="my-auto"> Supplier Responsibles </h1>
            <div class="card p-1">
                <Button data-cy="new_supplier_responsible_button" class="p-button-text p-button-success" @click="openModal" v-tooltip.left="'New Supplier Responsibles'">
                    <i class="pi pi-plus" style="font-size: 1.5rem" ></i>
                </Button>
            </div>
        </div>
        <div v-else class="flex justify-content-end align-items-end">
            <div class="card p-1 mb-0">
                <Button class="p-button-text p-button-success" @click="openModal" v-tooltip.left="'New Supplier Responsibles'">
                    <i class="pi pi-plus" style="font-size: 1rem" ></i>
                </Button>
            </div>
        </div>

        <Dialog data-cy="new_supplier_responsible_modal" header="New Supplier Responsible" v-model:visible="displayModal" :modal="true" :breakpoints="{'960px': '90vw'}" :style="{width: '50vw'}">
            <div class="container">
                <form id="from_new_supplier_responsible" @submit.prevent="handleSubmit(!v$.$invalid)" class="p-fluid">
                    <div class="row justify-content-center">
                        <div class="col-10 md:col-12 pt-3">
                            <div class="p-float-label">     
                                <InputText id="name" v-model="v$.name.$model" :class="{'p-invalid':v$.name.$invalid && submitted || supplier_responsible_errors.name}" />
                                <label for="name" :class="{'p-error':v$.name.$invalid && submitted}"> Name* </label>
                                <small v-if="Object.keys(supplier_responsible_errors).length !== 0 && supplier_responsible_errors.name" class="p-error"><span v-for="error in supplier_responsible_errors.name" :key="error">{{error}}<br></span></small>
                            </div>
                            <small v-if="(v$.name.$invalid && submitted) || v$.name.$pending.$response" class="p-error">{{v$.name.required.$message.replace('Value', 'Name')}}</small>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-10 md:col-12 pt-3">
                            <div class="p-float-label">     
                                <InputText id="phone" v-model="v$.phone.$model" :class="{'p-invalid':v$.phone.$invalid && submitted || supplier_responsible_errors.phone}" />
                                <label for="phone" :class="{'p-error':v$.phone.$invalid && submitted}"> Phone* </label>
                                <small v-if="Object.keys(supplier_responsible_errors).length !== 0 && supplier_responsible_errors.phone" class="p-error"><span v-for="error in supplier_responsible_errors.phone" :key="error">{{error}}<br></span></small>
                            </div>
                            <small v-if="(v$.phone.$invalid && submitted) || v$.phone.$pending.$response" class="p-error">{{v$.phone.required.$message.replace('Value', 'Phone')}}</small>
                        </div> 
                    </div> 
                    <div class="row justify-content-center">
                        <div class="col-10 md:col-12 pt-3">
                            <div class="p-float-label">
                                <Dropdown data-cy="dropdown_supplier" id="id_supplier" v-model="id_supplier" :options="all_suppliers" optionLabel="name" :filter="true" placeholder="Supplier*" :class="{'p-invalid':v$.id_supplier.$invalid && submitted || supplier_responsible_errors.id_supplier}">
                                    <template #value="slotProps">
                                        <div v-if="!id_supplier">
                                            <span> {{slotProps.placeholder}} </span>
                                        </div>
                                        <div v-else-if="slotProps.value">
                                            <span>{{slotProps.value.name}}</span>
                                        </div>
                                    </template>
                                    <template #option="slotProps">
                                        <div> {{slotProps.option.name}}</div>
                                    </template>
                                </Dropdown>
                            </div>
                            <small v-if="Object.keys(supplier_responsible_errors).length !== 0 && supplier_responsible_errors.id_supplier" class="p-error"><span v-for="error in supplier_responsible_errors.id_supplier" :key="error">{{error}}<br></span></small>
                        </div>
                        <small v-if="(v$.id_supplier.$invalid && submitted) || v$.id_supplier.$pending.$response" class="p-error">{{v$.id_supplier.required.$message.replace('Value', 'Supplier')}}</small>
                    </div> 
                </form>
            </div>
            <template #footer>
                <Button data-cy="create_supplier_responsible_button" form="from_new_supplier_responsible" type="submit" label="Submit" class="p-button-raised"/>
            </template>
        </Dialog>
    </div>
</template>

<script>
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import InputText from 'primevue/inputtext'
import Toast from 'primevue/toast'
import Dropdown from 'primevue/dropdown'
import { required } from '@vuelidate/validators'
import { useVuelidate } from "@vuelidate/core";

export default {
    setup: () => ({ v$: useVuelidate() }),
    components: {
        Dialog,
        Button,
        Dropdown,
        InputText,
        Toast,
    },
    props: {
        service_sheet: {
            type: Boolean
        }
    },
    data() {
        return {
            displayModal: false,
            name: '',
            phone: '',
            id_supplier:'',
            supplier_responsible_errors: {},
            submitted: false,
            showMessage: false,
        }
    },
    computed: {
        all_suppliers: function() {
            return this.$store.getters.all_suppliers
        },
        get_supplier_responsible_errors: function() {
            return this.$store.getters.get_supplier_responsible_errors
        }
    },
    methods: {
        openModal() {
            this.displayModal = true;
        },
        closeModal() {
            this.displayModal = false;
        },
        async add_supplier_responsible() {
            let supplier_responsible = { 
                name: this.name,
                phone: this.phone,
                id_supplier:this.id_supplier,
            }
            await this.$store.dispatch('create_supplier_responsible', supplier_responsible)
            this.supplier_responsible_errors = this.get_supplier_responsible_errors
            if(Object.keys(this.supplier_responsible_errors).length === 0){
                this.toggleDialog();
                this.resetForm();
                return true
            }
            return false

        },
        async handleSubmit(isFormValid) {
            this.submitted = true;
            
            if (!isFormValid) {
                return;
            }

            let res = await this.add_supplier_responsible()

            if (res){
                this.$toast.removeAllGroups();
                this.$toast.add({severity:'success', summary: 'Successful', detail: 'Supplier responsible added', life: 3000});
            }
        },
        toggleDialog() {
            this.showMessage = !this.showMessage;
            this.closeModal()

            if(!this.showMessage) {
                this.resetForm();
            }
        },
        resetForm() {
            this.name = '';
            this.phone = '';
            this.id_supplier = null;
            this.submitted = false;
        }
    },
    validations() {
        return {
            name: { required },
            phone: { required },
            id_supplier: { required },

        }
    },
};
</script>

<style scoped>
</style>